import { yupResolver } from "@hookform/resolvers/yup";
import {
  toastrCRUDSuccess,
  toastrErrorAlert,
} from "components/Common/AlertToastr";
import { CommonButton } from "components/Common/ButtonCommon";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import { ComponentCheckbox } from "components/Common/inputCommon";
import Spacer from "components/Common/Spacing";
import { CommonText } from "components/Common/TextCommon";
import InputField from "components/form-control/InputField";
import SelectField from "components/form-control/Select";
import Table from "components/form-control/Table";
import useGetFormSchema from "custom-hook/useGetFormSchema";
import { TEXT_POST, TEXT_PUT } from "helpers/name_helper";
import { GET_PRODUCTS } from "helpers/url_helper";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Card, Col, Container, Row } from "reactstrap";
import httpService from "services/httpService";
import * as yup from "yup";

const periodsOptions = [
  { index: 1, name: "1 tháng", value: 1 },
  { index: 2, name: "3 tháng", value: 3 },
  { index: 3, name: "6 tháng", value: 6 },
  { index: 4, name: "9 tháng", value: 9 },
  { index: 5, name: "12 tháng", value: 12 },
  { index: 6, name: "24 tháng", value: 24 },
  { index: 7, name: "36 tháng", value: 36 },
  { index: 8, name: "48 tháng", value: 48 },
];

const HEADERS0 = [
  {
    text: "Kỳ hạn",
    CellComponent: SelectField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `durations.${indexOfRow}.periods`,
      options: periodsOptions,
    }),
  },
];

const HEADERS1 = [
  {
    text: "Chu kỳ rút lãi",
    CellComponent: SelectField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_vsGroup.${indexOfRow}.periods`,
      options: periodsOptions,
    }),
  },
  {
    text: "Lãi suất thưởng cố định (%) ",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_vsGroup.${indexOfRow}.bonus`,
      // type: "number",
      // max: 100,
      // min: 0,
    }),
  },
];

const HEADERS2 = [
  {
    text: "Chu kỳ rút lãi",
    CellComponent: SelectField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_vsetNature.${indexOfRow}.periods`,
      options: periodsOptions,
    }),
  },
  {
    text: "Lãi suất thưởng cố định (%) ",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_vsetNature.${indexOfRow}.bonus`,
      type: "number",
      max: 100,
      min: 0,
    }),
  },
];

const HEADERS3 = [
  {
    text: "Chu kỳ rút lãi",
    CellComponent: SelectField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_truongGia.${indexOfRow}.periods`,
      options: periodsOptions,
    }),
  },
  {
    text: "Lãi suất thưởng cố định (%) ",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_truongGia.${indexOfRow}.bonus`,
      type: "number",
      max: 100,
      min: 0,
    }),
  },
];

export default function NewInvestmentPackage() {
  const { id } = useParams();

  useEffect(async () => {
    if (!id) return;

    const response = await httpService.get(GET_PRODUCTS + `/${id}`);

    const checkisActiclveTable = Object.entries(
      response?.attributes[2]?.newVersion
    ).map(([key, value]) => key);

    reset({
      ...response,
      durations:
        response?.attributes &&
        Object.keys(response?.attributes[0].durations || {}).map(item => ({
          periods: item.toString(),
        })),
      ...(checkisActiclveTable.includes("VS GROUP") && {
        tb_vsGroup:
          response?.attributes &&
          Object.entries(
            response?.attributes[2].newVersion["VS GROUP"].periods || {}
          ).map(([key, value]) => ({
            periods: key,
            bonus: value.bonus,
          })),
        interest_vsGroup:
          (response?.attributes &&
            response?.attributes[2].newVersion["VS GROUP"].interest) ||
          "",
      }),

      ...(checkisActiclveTable.includes("VSETNATURE") && {
        tb_vsetNature:
          response?.attributes &&
          Object.entries(
            response?.attributes[2].newVersion["VSETNATURE"].periods || {}
          ).map(([key, value]) => ({
            periods: key,
            bonus: value.bonus,
          })),
        interest_vsetNature:
          (response?.attributes &&
            response?.attributes[2].newVersion["VSETNATURE"].interest) ||
          "",
      }),

      ...(checkisActiclveTable.includes("TRƯƠNG GIA") && {
        tb_truongGia:
          response?.attributes &&
          Object.entries(
            response?.attributes[2].newVersion["TRƯƠNG GIA"].periods || {}
          ).map(([key, value]) => ({
            periods: key,
            bonus: value.bonus,
          })),
        interest_truongGia:
          (response?.attributes &&
            response?.attributes[2].newVersion["TRƯƠNG GIA"].interest) ||
          "",
      }),
    });

    if (checkisActiclveTable.includes("VS GROUP")) {
      setIsActiveTable(prev => ({
        ...prev,
        tbVsGroup: true,
      }));
      setValue("ck_vsgroup", true);
    }

    if (checkisActiclveTable.includes("VSETNATURE")) {
      setIsActiveTable(prev => ({
        ...prev,
        tbVsetNature: true,
      }));
      setValue("ck_vsetnature", true);
    }

    if (checkisActiclveTable.includes("TRƯƠNG GIA")) {
      setIsActiveTable(prev => ({
        ...prev,
        tbTruongGia: true,
      }));
      setValue("ck_truonggia", true);
    }
  }, []);

  useEffect(() => {
    const { reset } = formProps;
    reset({
      durations: [{ periods: "12" }, { periods: "24" }, { periods: "36" }],
    });
  }, []);

  const [createdData, setData] = useState({
    newVersion: {},
  });

  const [isActiveTable, setIsActiveTable] = useState({
    tbVsGroup: false,
    tbVsetNature: false,
    tbTruongGia: false,
  });

  const initialDepartment = {
    vsgroupCheck: "",
    vsetNature: "",
    truongGia: "",
  };
  const schema = yup
    .object()
    .shape({
      name: yup.string().required("Trường này bắt buộc"),
      sellingPrice: yup.string().required("Trường này bắt buộc"),
      // interest_vsGroup: yup.number().typeError("Hãy nhập số"),
      // interest_vsetNature: yup.number().typeError("Hãy nhập số"),
      // interest_truongGia: yup.number().typeError("Hãy nhập số"),
    })
    .required();
  const {
    handleSubmit,
    formState: { errors },
    ...formProps
  } = useForm({
    mode: "onBlur",
    initialDepartment,
    resolver: yupResolver(schema),
  });
  const { reset, register, setValue } = formProps;

  const { renderForm, uploadImg } = useGetFormSchema(
    "Product",
    yup,
    formProps,
    errors
  );

  console.log("errors", errors);

  const handleChangeCheckTb1 = e => {
    setIsActiveTable(prev => ({
      ...prev,
      tbVsGroup: e.target.checked,
    }));
  };

  const handleChangeCheckTb2 = e => {
    setIsActiveTable(prev => ({
      ...prev,
      tbVsetNature: e.target.checked,
    }));
  };

  const handleChangeCheckTb3 = e => {
    setIsActiveTable(prev => ({
      ...prev,
      tbTruongGia: e.target.checked,
    }));
  };

  const onSubmit = async value => {
    let objNewVersion = { newVersion: {} };
    let objDurations = { durations: {} };
    let attributeObject = {};
    let newObject = [];

    //object Durations
    let objDurationTemp = {};
    for (let item in value.durations) {
      Object.assign(objDurationTemp, {
        [value.durations[item].periods]: {},
      });
    }
    objDurations.durations = objDurationTemp;

    //object Durations
    if (
      value.tb_vsGroup &&
      value.tb_vsGroup.length !== 0 &&
      isActiveTable.tbVsGroup === true
    ) {
      createdData.newVersion = {
        ["VS GROUP"]: {
          interest: value.interest_vsGroup,
          periods: {},
        },
      };
      let obj = {};
      for (let item in value.tb_vsGroup) {
        Object.assign(obj, {
          [value.tb_vsGroup[item].periods]: {
            bonus: Number(value.tb_vsGroup[item].bonus),
          },
        });
      }
      createdData.newVersion["VS GROUP"].periods = obj;
      Object.assign(objNewVersion.newVersion, createdData.newVersion);
    }

    if (
      value.tb_vsetNature &&
      value.tb_vsetNature.length !== 0 &&
      isActiveTable.tbVsetNature === true
    ) {
      createdData.newVersion = {
        ["VSETNATURE"]: {
          interest: value.interest_vsetNature,
          periods: {},
        },
      };
      let obj = {};
      for (let item in value.tb_vsetNature) {
        Object.assign(obj, {
          [value.tb_vsetNature[item].periods]: {
            bonus: Number(value.tb_vsetNature[item].bonus),
          },
        });
      }
      createdData.newVersion["VSETNATURE"].periods = obj;
      Object.assign(objNewVersion.newVersion, createdData.newVersion);
    }

    if (
      value.tb_truongGia &&
      value.tb_truongGia.length !== 0 &&
      isActiveTable.tbTruongGia === true
    ) {
      createdData.newVersion = {
        ["TRƯƠNG GIA"]: {
          interest: value.interest_truongGia,
          periods: {},
        },
      };
      let obj = {};
      for (let item in value.tb_truongGia) {
        Object.assign(obj, {
          [value.tb_truongGia[item].periods]: {
            bonus: Number(value.tb_truongGia[item].bonus),
          },
        });
      }
      createdData.newVersion["TRƯƠNG GIA"].periods = obj;
      Object.assign(objNewVersion.newVersion, createdData.newVersion);
    }

    Object.assign(
      attributeObject,
      objDurations,
      { investment: [] },
      objNewVersion
    );
    const imageUpload = await uploadImg(value.image);
    Object.keys(attributeObject).map(item => {
      if (item === "durations") {
        newObject.push({
          durations: attributeObject[item],
        });
        return;
      }
      if (item === "investment") {
        newObject.push({
          investment: [],
        });
        return;
      }
      newObject.push({
        newVersion: attributeObject[item],
      });
    });

    const product = {
      name: value.name,
      isActive: value.isActive,
      attributes: [...newObject],
      image: imageUpload,
      sellingPrice: Number(value.sellingPrice.replaceAll(".", "")),
      isAllowedSaving: false,
      category: {
        objectId: "xq5CDHNdoC",
        className: "Category",
        __type: "Pointer",
      },
    };

    if (id) {
      try {
        const res = await httpService.put(GET_PRODUCTS + `/${id}`, product);
        if (res?.updatedAt) {
          toastrCRUDSuccess("Product", TEXT_PUT);
          return;
        }
        toastrErrorAlert("Đã xảy ra lỗi. Vui lòng thử lại sau!!");
      } catch (error) {
        toastrErrorAlert("Đã xảy ra lỗi. Vui lòng thử lại sau!!");
      }
      return;
    }
    try {
      const res = await httpService.post(GET_PRODUCTS, product);
      if (res?.createdAt) {
        toastrCRUDSuccess("Product", TEXT_POST);
        return;
      }
      toastrErrorAlert("Đã xảy ra lỗi. Vui lòng thử lại sau!!");
    } catch (error) {
      toastrErrorAlert("Đã xảy ra lỗi. Vui lòng thử lại sau!!");
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <form onSubmit={handleSubmit(onSubmit)}>
          <HeaderCreateItem title={"Thêm / Sửa Gói Đầu Tư"}>
            <CommonButton level={0}>Save</CommonButton>
          </HeaderCreateItem>
          <Card body>
            <Row>
              <Col xs={4}>{renderForm([])}</Col>
              <Col xs={8}>
                <div>
                  <Table
                    headers={HEADERS0}
                    formProps={{
                      errors,
                      ...formProps,
                    }}
                    name="durations"
                  />
                </div>
                <Spacer size={50} />
                <div>
                  <div className="d-flex flex-column justify-content-start align-items-start">
                    <CommonText
                      className="text-nowrap my-0"
                      level={1}
                      style={{ minWidth: "8rem" }}
                    >
                      VS GROUP
                    </CommonText>

                    <ComponentCheckbox
                      style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
                    >
                      <input
                        type="checkbox"
                        {...register("ck_vsgroup", {
                          onChange: e => handleChangeCheckTb1(e),
                        })}
                      />
                      <CommonText style={{ marginLeft: 5, marginTop: 0 }}>
                        Hoạt động
                      </CommonText>
                    </ComponentCheckbox>

                    <div>
                      {isActiveTable.tbVsGroup && (
                        <>
                          <CommonText style={{ marginLeft: 5, marginTop: 0 }}>
                            Lãi suất cố định (%)
                          </CommonText>
                          <InputField
                            name="interest_vsGroup"
                            {...formProps}
                            style={{
                              width: "10rem",
                            }}
                            errors={errors}
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <Spacer size={20} />
                  {isActiveTable.tbVsGroup && (
                    <Table
                      headers={HEADERS1}
                      formProps={{
                        errors,
                        ...formProps,
                      }}
                      name="tb_vsGroup"
                    />
                  )}
                </div>
                <Spacer size={50} />
                <div>
                  <div className="d-flex flex-column justify-content-start align-items-start">
                    <CommonText
                      className="text-nowrap my-0"
                      level={1}
                      style={{ minWidth: "8rem" }}
                    >
                      VSET NATURE
                    </CommonText>
                    <ComponentCheckbox
                      style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
                    >
                      <input
                        type="checkbox"
                        {...register("ck_vsetnature", {
                          onChange: e => handleChangeCheckTb2(e),
                        })}
                      />
                      <CommonText style={{ marginLeft: 5, marginTop: 0 }}>
                        Hoạt động
                      </CommonText>
                    </ComponentCheckbox>
                    <div>
                      {isActiveTable.tbVsetNature && (
                        <>
                          <CommonText style={{ marginLeft: 5, marginTop: 0 }}>
                            Lãi suất cố định (%)
                          </CommonText>
                          <InputField
                            name="interest_vsetNature"
                            {...formProps}
                            style={{
                              width: "10rem",
                            }}
                            errors={errors}
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <Spacer size={20} />
                  {isActiveTable.tbVsetNature && (
                    <Table
                      headers={HEADERS2}
                      formProps={{
                        errors,
                        ...formProps,
                      }}
                      name="tb_vsetNature"
                    />
                  )}
                </div>
                <Spacer size={50} />
                <div>
                  <div className="d-flex flex-column justify-content-start align-items-start">
                    <CommonText
                      className="text-nowrap my-0"
                      level={1}
                      style={{ minWidth: "8rem" }}
                    >
                      TRƯƠNG GIA
                    </CommonText>
                    <ComponentCheckbox
                      style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
                    >
                      <input
                        type="checkbox"
                        {...register("ck_truonggia", {
                          onChange: e => handleChangeCheckTb3(e),
                        })}
                      />
                      <CommonText style={{ marginLeft: 5, marginTop: 0 }}>
                        Hoạt động
                      </CommonText>
                    </ComponentCheckbox>
                    <div>
                      {isActiveTable.tbTruongGia && (
                        <>
                          <CommonText style={{ marginLeft: 5, marginTop: 0 }}>
                            Lãi suất cố định (%)
                          </CommonText>
                          <InputField
                            name="interest_truongGia"
                            {...formProps}
                            style={{
                              width: "10rem",
                            }}
                            errors={errors}
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <Spacer size={20} />
                  {isActiveTable.tbTruongGia && (
                    <Table
                      headers={HEADERS3}
                      formProps={{
                        errors,
                        ...formProps,
                      }}
                      name="tb_truongGia"
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Card>
        </form>
      </Container>
    </div>
  );
}
